__turbopack_context__.v({
  "alignCenter": "SectionHeader-module__GxG6rW__alignCenter",
  "alignLeft": "SectionHeader-module__GxG6rW__alignLeft",
  "alignRight": "SectionHeader-module__GxG6rW__alignRight",
  "container": "SectionHeader-module__GxG6rW__container",
  "content": "SectionHeader-module__GxG6rW__content",
  "eyebrow": "SectionHeader-module__GxG6rW__eyebrow",
  "eyebrowIcon": "SectionHeader-module__GxG6rW__eyebrowIcon",
  "eyebrowRow": "SectionHeader-module__GxG6rW__eyebrowRow",
  "full": "SectionHeader-module__GxG6rW__full",
  "justifyCenter": "SectionHeader-module__GxG6rW__justifyCenter",
  "justifyEnd": "SectionHeader-module__GxG6rW__justifyEnd",
  "justifyStart": "SectionHeader-module__GxG6rW__justifyStart",
  "row": "SectionHeader-module__GxG6rW__row",
  "textWrap": "SectionHeader-module__GxG6rW__textWrap",
  "wLg": "SectionHeader-module__GxG6rW__wLg",
  "wMd": "SectionHeader-module__GxG6rW__wMd",
  "wSm": "SectionHeader-module__GxG6rW__wSm",
});
